<template>
  <section class="global-box">
    <div class="content-box">
      <h2>Fale conosco</h2>
      <p>
        Nossa equipe esta pronta para atender a sua necessidade de forma rápida,
        prática e personalizada. Entre em contato agora mesmo, retornaremos o seu
        contato o mais breve possível!
      </p>
      <form class="form-global" novalidate @submit.prevent="validateData">
        <div class="wrap-form">
          <md-field class="name" :class="getValidationClass('name')">
            <label>Nome</label>
            <md-input v-model="formRegister.name" required />
            <span class="md-error" v-if="!$v.formRegister.name.required">
              Campo obrigatório
            </span>
            <span class="md-error" v-if="!$v.formRegister.name.minLength">
              Campo com quantidade mínima de caracteres
            </span>
          </md-field>
          <md-field class="mail" :class="getValidationClass('mail')">
            <label>E-mail</label>
            <md-input v-model="formRegister.mail" required />
            <span class="md-error" v-if="!$v.formRegister.mail.required">
              Campo obrigatório
            </span>
            <span class="md-error" v-if="!$v.formRegister.mail.email">
              Digite um e-mail válido
            </span>
          </md-field>
          <md-field class="phone" :class="getValidationClass('phone')">
            <label>Telefone</label>
            <md-input v-model="formRegister.phone" required />
            <span class="md-error" v-if="!$v.formRegister.phone.required">
              Campo obrigatório
            </span>
            <span class="md-error" v-if="!$v.formRegister.phone.minLength">
              Campo com quantidade mínima de caracteres
            </span>
          </md-field>
        </div>
        <md-field class="message" :class="getValidationClass('message')">
          <label>Mensagem</label>
          <md-textarea v-model="formRegister.message" required></md-textarea>
          <span class="md-error" v-if="!$v.formRegister.message.required">
            Campo obrigatório
          </span>
        </md-field>
        <div class="wrapper-button">
          <btn
            description="Enviar"
            small
            outline
            class="btn"
          />
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  name: 'contact-session',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formRegister: {
        name: '',
        mail: '',
        phone: '',
        message: '',
      },
    };
  },
  validations: {
    formRegister: {
      name: { required, minLength: minLength(3) },
      mail: { required, email },
      phone: { required, minLength: minLength(10) },
      message: { required },
    },
  },
  methods: {
    validateData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.sendData();
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.formRegister[fieldName];
      return (field) ? { 'md-invalid': field.$invalid && field.$dirty } : '';
    },
    async sendData() {
      this.request = true;
      this.$Services.requestForm.formPost({
        name: this.formRegister.name,
        mail: this.formRegister.mail,
        phone: this.formRegister.phone,
        message: this.formRegister.message,
        date: new Date().toLocaleString('pt-BR', { hour12: false }),
      }).then((res) => {
        this.request = false;
        if (res.success) {
          this.$Notification.open(
            this.$t('register.notifications.success'),
            'success',
          );
          setTimeout(() => {
            /* eslint-disable */
              location.replace('https://app.represente.com.br');
            /* eslint-enable */
          }, 1500);
        } else {
          this.$Notification.open(
            this.$t('register.notifications.error'),
            'error',
          );
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  section
    width: 100%
  .global-box
    padding: 0 !important
    overflow: initial !important
    .form-global
      width: 100%
      display: flex
      flex-wrap: wrap
      justify-content: space-between
      .wrap-form
        width: 48%
      .message
        width: 48%
        margin: 12px 0 24px
        textarea
          resize: none
          min-height: calc(100% - 16px)
      .wrapper-button
        width: 100%
        display: flex
        flex-wrap: wrap
        justify-content: flex-end
        margin-top: 12px
    @media (max-width: $widthTerciarySmall)
      .form-global
        .wrap-form, .message
          width: 100%
          textarea
            min-height: 120px
</style>
